import { configHome, DataSource } from "@pub/config";
import placeholders from "@pub/placeholders";
import { ContentBlock, LatestArticle } from "@sphtech/dmg-design-system";
import { NaturalCarousel } from "@sphtech/dmg-design-system";
import {
  extractHomeContentData,
  HomeLayoutProps,
} from "@src/app/layouts/Home/Elements/utils";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "./home.module.css";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
};

export default function FullWidthCarousel({
  data,
  dataSource,
}: Props): ReactNode {
  const ContentBlockItems = extractHomeContentData(data, dataSource);

  const mappedItems =
    ContentBlockItems &&
    ContentBlockItems.items.map((contentBlockItem, index) => (
      <div key={index} className={styles.fullWidthItemCarousel}>
        <LatestArticle
          {...contentBlockItem}
          sections={[]}
          mode="portrait"
          mobileMode="portrait"
          placeholders={placeholders}
        />
      </div>
    ));
  return (
    !!ContentBlockItems?.items.length && (
      <div className={styles.fullWidthCarousel}>
        <div className={cx(styles.bodyContainer, styles.gutter)}>
          <ContentBlock
            heading={ContentBlockItems.title}
            cta={{
              url: ContentBlockItems.url,
              name: "VIEW MORE",
              icon: configHome.viewMore?.icon,
            }}
            isHeadingClickable={configHome.isHeadingClickable ?? true}
            withDivider={configHome.headingDivider}
          >
            <div className={styles.fullWidthCarouselWrapper}>
              <div className={styles.fullWidthCarouselContainer}>
                <NaturalCarousel
                  isLooping={false}
                  showArrowsOnMobile
                  arrowSize={22}
                >
                  {mappedItems}
                </NaturalCarousel>
              </div>
            </div>
          </ContentBlock>
        </div>
      </div>
    )
  );
}
